
import React from 'react'
import { IProject } from './core/_models'
import { Link, useLocation } from 'react-router-dom'
import { getProjectStageLink } from '../../../utils/config'
import CustomDynamicTable from '../apps/components/CustomDynamicTable'
import { useAuth } from '../auth'
import { HtmlTruncateWithTooltip } from '../apps/components/HtmlTruncateWithTooltip'
import { formatBudget } from '../../../utils/formateNumber'

type Props = {
  projects: IProject[],
  page: number,
  perPage: number,
  total: number,
  setPage: (page: number) => void,
  setPerPage: (perPage: number) => void,
  sortKey: string | null,
  sortOrder: "asc" | "desc" | null,
  handleSortChange: (key: string, order: "asc" | "desc" | null) => void,
}
const ProjectList: React.FC<Props> = ({ projects, page, perPage, total, setPage, setPerPage, sortKey, sortOrder, handleSortChange }) => {
  const location = useLocation();
  const data = Object.fromEntries(new URLSearchParams(window.location.search));

  const { auth } = useAuth();

  const columns = [
    {
      key: 'name',
      label: 'Project Name',
      sortable: true,
      hideable: false,
      padding: '0.75rem 0.75rem',
      width: '500px',
      render: (info: IProject) => {
        const projectData = info
        return projectData.can_view_details ? <Link state={{ from: location.state?.from || location.pathname, }} to={`${getProjectStageLink(projectData.project_id)}/?label=${data.label}&dashboard=${data.dashboard}&url=${data.url}&filter=${data.filter}`}>
          <HtmlTruncateWithTooltip html={info.name as string} limit={60} className='text-gray-700 fw-bold text-hover-primary fs-6' />
        </Link> : <HtmlTruncateWithTooltip html={info.name as string} limit={60} className='text-gray-400 fw-bold fs-6' />
      }
    },
    {
      key: 'department_name',
      label: 'Department',
      sortable: true,
      padding: '0.75rem 0.75rem',
      width: '320px',
      render: (info: IProject) => {
        return <HtmlTruncateWithTooltip html={info.department_name as string} limit={40} />
      }
    },
    {
      key: 'sector_name',
      label: 'Sector',
      sortable: true,
      padding: '0.75rem 0.75rem',
      align: 'center',
      width: '150px',

    },
    {
      key: 'district_name',
      sortable: true,
      label: 'District Municipality',
      padding: '0.75rem 0.75rem',
      width: '200px',
      render: (info: IProject) => {
        return <HtmlTruncateWithTooltip html={info.district_name as string} limit={30} />
      }
    },
    {
      key: 'municipality_name',
      label: 'Local Municipality',
      padding: '0.75rem 0.75rem',
      width: '200px',
      render: (info: IProject) => {
        return <HtmlTruncateWithTooltip html={info.municipality_name as string} limit={30} />
      }
    },
    {
      key: 'priority',
      label: 'Timeline Priority',
      padding: '0.75rem 0.75rem',
      width: '200px',
      sortable: true,
    },
    {
      key: 'budget',
      label: 'Estimated Project Value',
      padding: '0.75rem 0.75rem',
      width: '200px',
      align: 'center',
      sortable: true,
      render: (info: IProject) => {
        return formatBudget(info.budget as number)
      }
    }
  ];

  return <CustomDynamicTable
    columns={columns}
    data={projects}
    showColumnManager
    storageKey={`my-projects-${auth?.user_id}`}
    pagination={{
      currentPage: page,
      totalCount: total,
      pageSize: perPage,
      onPageChange: (p) => setPage(p),
      onPageSizeChange: (size) => {
        setPerPage(size);
        setPage(1);
      },
    }}
    sortKey={sortKey}
    sortOrder={sortOrder}
    onSortChange={handleSortChange}
  />
}

export { ProjectList }
